import { render, staticRenderFns } from "./InformMessageList.vue?vue&type=template&id=00704377"
import script from "./InformMessageList.vue?vue&type=script&lang=js"
export * from "./InformMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports